export default {
  empty: "請填寫完整",
  fuzhicg: "複製成功",
  fuzhicc: "複製出現異常",
  login: {
    title: "SYSTEM LOGIN",
    logIn: "Login",
    username: "Account",
    password: "Password",
  },
  首页: "首頁",
  行情: "行情",
  财富: "財富",
  我的: "我的",
  忘记密码: "忘記密碼",
  确定: "確定",
  "忘记密码？": "忘記密碼？",
  登录: "登錄",
  注册: "註冊",
  云端钱包: "雲端錢包",
  世界顶尖安全保护: "世界頂尖安全保護",
  "独有资产增益，注册存币坐享收益": "獨有資產增益，註冊存幣坐享收益",
  "支持超过30+主流币和500+代币": "支持超過30+主流幣和500+代幣",
  HD钱包: "HD錢包",
  "100%掌管私钥，资产更放心": "100%掌管私密金鑰，資產更放心",
  "一键导入助记词，方便好用": "一鍵導入助記詞，方便好用",
  设置登录密码: "設置登錄密碼",
  确认: "確認",
  手机注册: "手機註冊",
  已有账号: "已有帳號",
  去登录: "去登錄",
  最近流行: "最近流行",
  全部: "全部",
  拖动排序: "拖動排序",
  立即创建: "立即創建",
  您支付: "您支付",
  可换余额: "可換餘額",
  请在以下时间内完成支付以锁定此汇率: "請在以下時間內完成支付以鎖定此匯率",
  您获得: "您獲得",
  "您获得的币种为空时,说明没有币种可以闪兑。":
    "您獲得的幣種為空時,說明沒有幣種可以閃兌。",
  立即兑换: "立即兌換",
  备份钱包助记词: "備份錢包助記詞",
  "1.由12个字符组成，请抄写并保管在安全的地方。":
    "1.由12個字元組成，請抄寫並保管在安全的地方。",
  "2.100%由您保管，一经丢失，无法找回。":
    "2.100%由您保管，一經丟失，無法找回。",
  "3.请在收币或卸载之前，务必完成助记词备份。":
    "3.請在收幣或卸載之前，務必完成助記詞備份。",
  立即备份: "立即備份",
  "我先看看，稍后再说": "我先看看，稍後再說",
  请环顾四周: "請環顧四周",
  "任何人获得助记词，意味着获取了您的资产，请确保周围无人，没有摄像头。":
    "任何人獲得助記詞，意味著獲取了您的資產，請確保周圍無人，沒有攝像頭。",
  知道了: "知道了",
  请输入验证码: "請輸入驗證碼",
  "没有收到验证码？": "沒有收到驗證碼？",
  交易时间: "交易時間",
  交易ID: "交易ID",
  来自: "來自",
  发送到: "發送到",
  备注: "備註",
  发送: "發送",
  闪兑: "閃兌",
  接收: "接收",
  交易记录: "交易記錄",
  "正在刷新...": "正在刷新...",
  "正在加载...": "正在載入...",
  暂无相关记录: "暫無相關記錄",
  重新设置支付密码: "重新設置支付密碼",
  "请将上方的16位恢复秘钥备份在安全的地方，遗失秘钥将无法恢复两步验证":
    "請將上方的16位恢復秘鑰備份在安全的地方，遺失秘鑰將無法恢復兩步驗證",
  我已设置并备份秘钥: "我已設置並備份秘鑰",
  "谷歌两步验证可以为您的账户增加一层保护，当您登陆或者进行交易时，在输入密码的同时，还需要来自两步验证的验证码":
    "谷歌兩步驗證可以為您的帳戶增加一層保護，當您登陸或者進行交易時，在輸入密碼的同時，還需要來自兩步驗證的驗證碼",
  "如何使用谷歌两步验证?": "如何使用谷歌兩步驗證?",
  筛选: "篩選",
  移除: "移除",
  添加: "添加",
  总资产: "總資產",
  创建钱包: "創建錢包",
  导入钱包: "導入錢包",
  邀请好友: "邀請好友",
  发红包: "發紅包",
  扫一扫: "掃一掃",
  地址簿: "地址簿",
  历史公告: "歷史公告",
  设置: "設置",
  请选择您的证件的颁发国家: "請選擇您的證件的頒發國家",
  查看助记词: "查看助記詞",
  "您可以导入一下助记词在其他设备上配对，或者用其他设备上的 HMC Wallet Pro 钱包扫描二维码配对。":
    "您可以導入一下助記詞在其他設備上配對，或者用其他設備上的 HMC Wallet Pro 錢包掃描二維碼配對。",
  "请勿截图！如果有人获取你的助记词将直接获取你的资产！":
    "請勿截圖！如果有人獲取你的助記詞將直接獲取你的資產！",
  查看加密二维码: "查看加密二維碼",
  "加密二维码是为了方便钱包配对新设备，请不要截屏保存，并且确保周围无其他人或者隐藏摄像头。":
    "加密二維碼是為了方便錢包配對新設備，請不要截屏保存，並且確保周圍無其他人或者隱藏攝像頭。",
  "该二维码仅限 HMC Wallet Pro 钱包使用。扫描时，需在将要导入的APP内输入当前APP的PIN码，方可成功导入对应的助记词。":
    "該二維碼僅限 HMC Wallet Pro 錢包使用。掃描時，需在將要導入的APP內輸入當前APP的PIN碼，方可成功導入對應的助記詞。",
  "请抄写 HMC Wallet Pro 助记词": "請抄寫 HMC Wallet Pro 助記詞",
  "HMC Wallet Pro 助记词用于恢复钱包，请按照顺序将下方的12个单词抄写到纸上，并保存到安全的地方。":
    "HMC Wallet Pro 助記詞用於恢復錢包，請按照順序將下方的12個單詞抄寫到紙上，並保存到安全的地方。",
  我已安全保存: "我已安全保存",
  "HMC Wallet Pro需要您提政府颁发的照片ID来通过安全验证":
    "HMC Wallet Pro需要您提政府頒發的照片ID來通過安全驗證",
  提交: "提交",
  设置收款金额: "設置收款金額",
  收款金额: "收款金額",
  复制收款码: "複製收款碼",
  取消: "取消",
  数量: "數量",
  "为了您的账户安全,请输入原支付密码确认身份。":
    "為了您的帳戶安全,請輸入原支付密碼確認身份。",
  "忘记支付密码?": "忘記支付密碼?",
  将配好的红包分享给好友: "將配好的紅包分享給好友",
  个: "個",
  "请确认 HMC Wallet Pro 助记词": "請確認 HMC Wallet Pro 助記詞",
  "为了确保您已将 HMC Wallet Pro 助记词正确的抄写，请选择对应序号的单词。":
    "為了確保您已將 HMC Wallet Pro 助記詞正確的抄寫，請選擇對應序號的單詞。",
  "为了您的资金安全，需要进一步的安全设置和实名信息才可以提币，提币限额会随之增加。":
    "為了您的資金安全，需要進一步的安全設置和實名資訊才可以提幣，提幣限額會隨之增加。",
  恢复助记词钱包: "恢復助記詞錢包",
  "请在下方的表格中输入助记词以回复钱包，在每个助记词输入完成后按“空格”键可以跳转到下个单词":
    "請在下方的表格中輸入助記詞以回復錢包，在每個助記詞輸入完成後按“空格”鍵可以跳轉到下個單詞",
  开始恢复: "開始恢復",
  "覆盖当前钱包？": "覆蓋當前錢包？",
  "导入钱包会覆盖当前钱包，如果您还未备份，当前钱包将会永远消失。":
    "導入錢包會覆蓋當前錢包，如果您還未備份，當前錢包將會永遠消失。",
  继续导入: "繼續導入",
  全部发送: "全部發送",
  交易费: "交易費",
  慢: "慢",
  快: "快",
  已有红包: "已有紅包",
  生成红包: "生成紅包",
  确认支付: "確認支付",
  可在已有红包页面查看领取详情: "可在已有紅包頁面查看領取詳情",
  级: "級",
  退出登录: "退出登錄",
  全部划转: "全部劃轉",
  查看规则: "查看規則",
  请输入支付密码: "請輸入支付密碼",
  币计划活期: "幣計畫活期",
  币计划定期: "幣計畫定期",
  预期年化收益: "預期年化收益",
  我的财富: "我的財富",
  币计划: "幣計畫",
  热门推荐: "熱門推薦",
  交易查询: "交易查詢",
  财富资产: "財富資產",
  累计收益: "累計收益",
  预期年化收益率: "預期年化收益率",
  交易规则: "交易規則",
  买入: "買入",
  起息日: "起息日",
  到期日: "到期日",
  产品亮点: "產品亮點",
  剩余额度: "剩餘額度",
  立即购买: "立即購買",
  昨日收益: "昨日收益",
  划入: "劃入",
  划出: "劃出",
  全部划出: "全部劃出",
  请输入谷歌二次验证码: "請輸入穀歌二次驗證碼",
  点击登录: "點擊登錄",
  "欢迎来到HMC Wallet Pro": "歡迎來到HMC Wallet Pro",
  邀请奖励: "邀請獎勵",
  每日快讯: "每日快訊",
  联系客服: "聯繫客服",
  邀请累计: "邀請累計",
  积分: "積分",
  好友注册人数: "好友註冊人數",
  好友注册: "好友註冊",
  人数: "人",
  一级好友数: "一級好友數",
  "积分 每人奖励": "積分 每人獎勵",
  二级好友数: "二級好友數",
  三级好友数: "三級好友數",
  一级好友数2: "一級好友數",
  二级好友数2: "二級好友數",
  三级好友数2: "三級好友數",
  "积分 每人奖励2": "積分 每人獎勵",
  好友存币数: "好友存幣數",
  邀请列表: "邀請列表",
  邀请注册: "邀請註冊",
  邀请存币: "邀請存幣",
  暂时没有邀请哦: "暫時沒有邀請哦",
  当前总额: "當前總額",
  积分账单: "積分帳單",
  任务: "任務",
  商城: "商城",
  "忘记PIN码？备份钱包后重新安装App并导入助记词后重置":
    "忘記PIN碼？備份錢包後重新安裝App並導入助記詞後重置",
  "为了保护您的资产安全，请先设置PIN码，PIN码会用于解锁钱包和发币。":
    "為了保護您的資產安全，請先設置PIN碼，PIN碼會用於解鎖錢包和發幣。",
  "PIN码为本地密码，请妥善保存，如果丢失，无法恢复":
    "PIN碼為本地密碼，請妥善保存，如果丟失，無法恢復",
  关闭PIN码: "關閉PIN碼",
  "扫码下载HMC Wallet Pro": "掃碼下載HMC Wallet Pro",
  "邀请码(点击复制)": "邀請碼(點擊複製)",
  查看邀请详情: "查看邀請詳情",
  我的订单: "我的訂單",
  正在进行中: "正在進行中",
  已经结束: "已經結束",
  人参与: "人參與",
  兑换金额: "兌換金額",
  商品详情: "商品詳情",
  兑换时间: "兌換時間",
  开始时间: "開始時間",
  结束时间: "結束時間",
  我的积分: "我的積分",
  我的剩余兑换额度: "我的剩餘兌換額度",
  库存总量: "庫存總量",
  剩余库存: "剩餘庫存",
  兑换比例: "兌換比例",
  确认兑换: "確認兌換",
  任务记录: "任務記錄",
  分享: "分享",
  请填写手机号: "請填寫手機號",
  验证码: "驗證碼",
  设置密码: "設置密碼",
  再次输入: "再次輸入",
  请填写密码: "請填寫密碼",
  邀请码: "邀請碼",
  我的Dapp钱包: "我的Dapp錢包",
  发现: "發現",
  搜索: "搜索",
  自定义排序: "自訂排序",
  货币: "貨幣",
  创建新地址: "創建新地址",
  名称: "名稱",
  地址: "地址",
  请输入金额: "請輸入金額",
  验证您的身份: "驗證您的身份",
  选择币种: "選擇幣種",
  设置支付密码: "設置支付密碼",
  谷歌两步验证码: "谷歌兩步驗證碼",
  谷歌两步验证: "谷歌兩步驗證",
  请输入搜索内容: "請輸入搜索內容",
  选择证件类型: "選擇證件類型",
  支付密码: "支付密碼",
  修改支付密码: "修改支付密碼",
  认证资料: "認證資料",
  国家: "國家",
  您的居住国家: "您的居住國家",
  姓名: "姓名",
  您的姓名全称: "您的姓名全稱",
  生日: "生日",
  居住地: "居住地",
  您现在的居住地: "您現在的居住地",
  证件ID: "證件ID",
  您的证件ID号码: "您的證件ID號碼",
  ID正面照片: "ID正面照片",
  ID反面照片: "ID反面照片",
  请输入数值: "請輸入數值",
  已配置红包: "已配置紅包",
  重置支付密码: "重置支付密碼",
  红包详情: "紅包詳情",
  安全等级: "安全等級",
  请输入收款地址: "請輸入收款位址",
  "备注(选填)": "備註(選填)",
  配置红包: "配置紅包",
  金额: "金額",
  红包数: "紅包數",
  请填写个数: "請填寫個數",
  红包总额度: "紅包總額度",
  红包数量: "紅包數量",
  祝福语: "祝福語",
  选择发送途径: "選擇發送途徑",
  云端钱包设置: "雲端錢包設置",
  账户名称: "帳戶名稱",
  注册时间: "註冊時間",
  请输入划入金额: "請輸入劃入金額",
  请输入转出金额: "請輸入轉出金額",
  谷歌二次验证: "穀歌二次驗證",
  默认货币: "默認貨幣",
  PIN码: "PIN碼",
  行情选项: "行情選項",
  服务协议: "服務協定",
  隐私政策: "隱私政策",
  帮助中心: "幫助中心",
  加入社群: "加入社群",
  加入社群2: "加入社群",
  我的邀请: "我的邀請",
  验证PIN码: "驗證PIN碼",
  设置PIN码: "設置PIN碼",
  行情显示色选项: "行情顯示色選項",
  请输入兑换金额: "請輸入兌換金額",
  任务中心: "任務中心",
  快讯: "快訊",
  "已开启(重置)": "已開啟(重置)",
  已开启: "已開啟",
  未开启: "未開啟",
  绿涨红跌: "綠漲紅跌",
  红涨绿跌: "紅漲綠跌",
  全部交易: "全部交易",
  增益收入: "增益收入",
  全部产品: "全部產品",
  全部币种: "全部幣種",
  当前余额: "當前餘額",
  钱包: "錢包",
  今日获得: "今日獲得",
  "我已备份好当前钱包，同意覆盖": "我已備份好當前錢包，同意覆蓋",
  备份助记词: "備份助記詞",
  "助记词即为私钥，它是掌管您财产的钥匙":
    "助記詞即為私密金鑰，它是掌管您財產的鑰匙",
  完成: "完成",
  下一步: "下一步",
  默认语言: "預設語言",
  "没有HMC Wallet Pro账号？": "沒有HMC Wallet Pro帳號？",
  获取验证码: "獲取驗證碼",
  验证错误: "驗證錯誤",
  验证成功: "驗證成功",
  验证失败: "驗證失敗",
  设置成功: "設置成功",
  请选择同意: "請選擇同意",
  云端钱包公告: "雲端錢包公告",
  HD钱包公告: "HD錢包公告",
  云端钱包地址簿: "雲端錢包地址簿",
  HD钱包地址簿: "HD錢包地址簿",
  收款地址: "收款地址",
  请填写完整: "請填寫完整",
  复制成功: "複製成功",
  复制出现异常: "複製出現異常",
  资产名: "資產名",
  交易量: "交易量",
  价格: "價格",
  "涨跌幅(24H)": "漲跌幅(24H)",
  内部转账: "內部轉賬",
  外部转账: "外部轉賬",
  请输入收款用户ID: "請輸入收款用戶ID",
  邮箱注册: "郵箱註冊",
  邮箱登录: "郵箱登錄",
  手机登录: "手機登錄",
  邮箱验证: "郵箱驗證",
  手机验证: "手機驗證",
  请填写邮箱号: "請填寫郵箱號",
  公链: "公鏈",
  游戏: "遊戲",
  我的游戏: "我的遊戲",
  社区: "社區",
  链游: "鏈遊",
  全部动态: "全部動態",
  热门游戏: "熱門遊戲",
  我的关注: "我的關注",
  发布: "發布",
  分享新鲜事: "分享新鮮事",
  发布动态: "發布動態",
  个人主页: "個人主頁",
  全文: "全文",
  评论: "評論",
  赞: "贊",
  没有更多了: "沒有更多了",
  暂无数据: "暫無數據",
  提示: "提示",
  "提币前必须绑定google验证码": "提幣前必須綁定Google驗證碼",
  请选择文件: "請選擇文件",
  请输入动态内容: "請輸入動態內容",
  确定删除该图片吗: "確定刪除該圖片嗎",
  上传文件类型错误: "上傳文件類型錯誤",
  请选择要上传的图片: "請選擇要上傳的圖片",
  匿名用户: "匿名用戶",
  收起: "片付け",
  查看所有评论: "查看所有評論",
  确定删除该动态吗: "确定删除该动态吗",
  动态详情: "動態詳情",
  删除: "刪除",
  有趣的评论万里挑一: "有趣的評論萬里挑一",
  请输入内容: "請輸入內容",
  回复: "回复",
  暂无签名: "暫無簽名",
  已关注: "已關注",
  关注: "關注",
  删除成功: "刪除成功",
  打开: "打開",
  写下你的评论: "寫下你的評論",
  个人资料: "個人資料",
  点击修改: "點擊修改",
  昵称: "暱稱",
  ID: "ID",
  手机号: "手機號",
  个性签名: "個性簽名",
  添加图片或视频: "添加圖片或視頻",
  可用资产: "可用資產",
  锁定资产: "鎖定資產",
  转账: "轉賬",
  收款: "收款",
  钱包管理: "錢包管理",
  锁仓截止日期: "鎖倉截止日期",
  锁定: "鎖定",
  交易所: "Exchange",
  量化交易: "Quantitative trading",
  角色信息: "角色信息",
  绑定角色: "綁定角色",
  服务区: "服務區",
  请选择服务区: "請選擇服務區",
  角色: "角色",
  请选择角色: "請選擇角色",
  绑定: "綁定",
  绑定成功: "綁定成功",
  立即绑定: "立即綁定",
  未绑定: "未綁定",
  noequal: "兩次輸入不相等",
  invite: "請輸入六位邀請碼",
  实名认证: "實名認證",
  认证失败: "認證失敗",
  修改密码: "修改密碼",
  立即认证: "立即認證",
  已认证: "已認證",
  待审核: "待稽核",
  邮箱: "郵箱",
  手机: "手機",
  谷歌验证器: "穀歌驗證器",
  两步验证: "兩部驗證",
  旧密码: "舊密碼",
  新密码: "新密碼",
  请确认新密码: "請確認新密碼",
  立即修改: "立即修改",
  请填写完整表单: "請填寫完整表單",
  两次密码不一致: "兩次密碼不一致",
  认证状态: "認證狀態",
  身份认证失败: "身份認證失敗",
  失败原因: "失敗原因",
  重新认证: "重新認證",
  审核中: "稽核中",
  已完成身份认证: "已完成身份認證",
  国籍: "國籍",
  类型: "類型",
  身份证: "身份證",
  护照: "護照",
  驾照: "駕照",
  证件号码: "證件號碼",
  已完成实名认证: "已完成實名認證",
  身份验证: "身份驗證",
  请输入手机验证码: "請輸入手機驗證碼",
  发送验证码: "發送驗證碼 ",
  请输入邮箱验证码: "請輸入郵箱驗證碼",
  请输入谷歌验证码: "請輸入穀歌驗證碼",
  输入邮箱验证码: "輸入郵箱驗證碼",
  输入手机验证码: "輸入手機驗證碼",
  输入谷歌验证码: "輸入穀歌驗證碼",
  谷歌验证: "穀歌驗證",
  立即验证: "立即驗證",
  发送验证码至手机: "發送驗證碼至手機",
  发送验证码至邮箱: "發送驗證碼至郵箱",
  忘记支付密码: "忘記支付密碼",
  输入新密码: "輸入新密碼",
  请再次输入: "請再次輸入",
  请输入密码: "請輸入密碼",
  请输入邮箱: "請輸入郵箱",
  绑定邮箱: "綁定郵箱",
  请输入手机号: "請輸入手機號",
  区号: "區號",
  请选择区号: "請選擇區號",
  绑定手机号: "綁定手機號",
  "谷歌验证可以为您的账户增加一层保护，当您登录或者进行交易时，再输密码的同时，还需要来自谷歌验证的验证码":
    "穀歌驗證可以為您的帳戶新增一層保護，當您登入或者進行交易時，再輸密碼的同時，還需要來自穀歌驗證的驗證碼",
  "如何使用谷歌验证器?": "如何使用穀歌驗證器?",
  可用余额不足: "可用餘額不足",
  地址格式不正确: "地址格式不正確",
  金额不足10: "金額不足10",
  提币数量不能小于: "提幣數量不能小於",
  "您还未进行实名认证,请先进行实名认证": "您還未進行實名認證，請先進行實名認證",
  "您还未同时绑定手机号和邮箱，请前往设置页完善": "您還未同時綁定手機號和郵箱，請前往設置頁完善",
  "为保障账号安全，请绑定手机后再继续操作": "為保障帳號安全，請綁定手機後再繼續操作",
  "为保障账号安全，请绑定邮箱后再继续操作": "為保障帳號安全，請綁定郵箱後再繼續操作",
  "去绑定": "去綁定",
  至少为10: "至少為10",
  全选: "全選",
  删除: "刪除",
  请先勾选地址: "請先勾選地址",
  新建地址: "新建地址",
  提币网络: "提幣網絡",
  收款网络: "收款網絡",
  韩国: "韓國",
  "操作成功!": "操作成功",
  日本: "日本",
  其他: "其他",
  请上传手持证件照片: "請上傳手持證件照片",
  请把信息填写完整: "請把資訊填寫完整",
  请上传所需图片: "請上傳所需圖片",
  两步验证登录: "兩步驗證登入",
  请选择验证方式: "請選擇驗證管道",
  验证方式: "驗證方式",
  验证登录: "驗證登入",
  短信验证: "簡訊驗證",
  证件类型: "類型",
  暂无内容: "暫無內容",
  邮箱地址不符合格式: "郵箱地址不符合格式",
  下拉刷新: "下拉重繪",
  释放更新: "釋放更新",
  修改个性签名: "修改個性簽名",
  修改昵称: "修改昵稱",
  wrongpwd: "字母大小寫+數位不能低於8比特，暫不支持使用特殊符號",
  导入NFT: "導入NFT",
  请输入NFT合约地址: "請輸入NFT合約地址",
  请输入收藏品ID: "請輸入收藏品ID",
  币种: "幣種",
  添加收藏品: "添加收藏品",
  暂无NFT收藏: "暫無NFT收藏",
  确认删除此专辑吗: "確認刪除此專輯嗎",
  确认删除此收藏品吗: "確認刪除此收藏品嗎",
  编号: "編號",
  删除收藏品: "刪除收藏品",
  保存收款码: "保存收款碼",
  "没有HMC Wallet Pro账号？ 注册": "沒有HMC Wallet Pro賬號？註冊",
  "已有账号，去登录": "已有賬號，去登錄",
  导入NFT: "導入NFT",
  接收地址: "接收地址",
  添加收藏品: "添加收藏品",
  暂无NFT收藏: "暫無NFT收藏",
  编号: "編號",
  删除: "刪除",
  转出: "轉出",
  确认删除此收藏品吗: "確認刪除此收藏品嗎",
  确认删除此专辑吗: "確認刪除此專輯嗎",
  地址: "地址",
  请输入NFT合约地址: "請輸入NFT合約地址",
  请输入收藏品ID: "請輸入收藏品ID",
  添加: "添加",
  NFT接收地址: "NFT接收地址",
  复制: "複製",
  此地址仅用于NFT钱包地址接收使用: "此地址僅用於NFT錢包地址接收使用",
  转出NFT: "轉出NFT",
  合约地址: "合約地址",
  转出网络: "轉出網絡",
  藏品编号: "藏品編號",
  转出地址: "轉出地址",
  "此交易属不可逆,为避免您的资产损失,请仔细核对转出地址、网络,是否准确无误。":
    "此交易屬不可逆,為避免您的資產損失,請仔細核對轉出地址、網絡,是否準確無誤",
  请输入转出地址: "請輸入轉出地址",
  NFT历史记录: "NFT歷史記錄",
  时间: "時間",
  转入详情: "轉入詳情",
  已转出: "已轉出",
  交易详情: "交易詳情",
  发送地址: "發送地址",
  接收地址: "接收地址",
  网络: "網絡",
  交易哈希: "交易雜湊",
  NFT合约地址: "NFT合約地址",
  NFT编号: "NFT編號",
  交易时间: "交易時間",
  最小提币金额: "最小提幣金額",
};
